import { FC } from "react";
import { Item, Wrapper } from "./Catagories.styled";
import Section from "./Section";
interface Props {
  terms: {
    items: any;
  };
  handleSearchCatagory: any;
  handleSearchDates: any;
}

const Catagories: FC<Props> = ({
  terms,
  handleSearchCatagory,
  handleSearchDates,
}) => {
  return (
    <Wrapper>
      <Section title="Section">
        {terms?.items.map((item: any) => (
          <Item key={item.id} onClick={() => handleSearchCatagory(item)}>
            {item.name}
          </Item>
        ))}
      </Section>
      <Section title="Dates">
        {["", "", "", "", "", "", "", "", "", ""].map((item, i) => {
          if (i === 0) {
            return (
              <Item key={i} onClick={() => handleSearchDates(null, null)}>
                Last 14 days
              </Item>
            );
          }
          if (i === 1) {
            return (
              <Item key={i} onClick={() => handleSearchDates(0, null)}>
                {new Date().getFullYear()}
              </Item>
            );
          }
          return (
            <Item key={i} onClick={() => handleSearchDates(i + 1, i)}>
              {new Date().getFullYear() - (i - 1)}
            </Item>
          );
        })}
      </Section>
    </Wrapper>
  );
};

export default Catagories;
